<template>
  <div class="brand-facet cell">
    <Search
      v-model="brandSearch"
      :placeholder="brand === 'mcom' ? 'Search by brand' : 'Search by Designer'"
    />
    <div
      v-if="brand === 'mcom'"
      class="all_brands_label medium"
    >
      All Brands
    </div>
    <div
      v-else
      class="all_designers_label medium"
    >
      All Designers
    </div>
    <MultiSelectDefault
      :facet="facet"
      :scroll-to-selected="scrollToSelected"
      :custom-value-renderer="customValueRenderer"
      :is-dynamic="isDynamic"
      :should-restore-scroll="shouldRestoreScroll"
      :no-values-found-message="
        brand === 'mcom'
          ? 'No brands match your search.'
          : `We couldn't find a match.`
      "
      :render-during-ssr="renderDuringSsr"
      @onClearAll="clearBrandSearch"
    />
  </div>
</template>
<script setup>
import Search from '@atomic-ui/search';
import { brand } from 'config';
import MultiSelectDefault from './MultiSelectDefault';
import useBrandFacet from '../../composables/useBrandFacet';

const props = defineProps({
  facet: {
    type: Object,
    required: true,
  },
  scrollToSelected: {
    type: Boolean,
    default: () => false,
  },
  keepSearchValue: {
    type: Boolean,
    required: false,
  },
  isDynamic: {
    type: Boolean,
    default: () => false,
  },
  renderDuringSsr: {
    type: Boolean,
    default: false,
  },
  shouldRestoreScroll: {
    type: Boolean,
  },
});
const { brandSearch, customValueRenderer, clearBrandSearch } = useBrandFacet(props);
</script>

<style scoped>
.all_brands_label,
.all_designers_label {
  margin: 24px 0;
}
</style>
